/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import notification from "../config/notifications.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { MAKE_SECTIONS_VIP } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface MakeSectionsVIPProps {
  sectionIds: string[];
  isVip: boolean;
}

export interface IMakeSectionsVIPMethods extends IPluginMethodMap {
  getMakeSectionsVIP(args: MakeSectionsVIPProps): Promise<any>;
}

export class MakeSectionsVIPService implements IAgentPlugin {
  readonly methods: IMakeSectionsVIPMethods;

  constructor() {
    this.methods = {
      getMakeSectionsVIP: this.getMakeSectionsVIP.bind(this),
    };
  }

  async getMakeSectionsVIP(args: MakeSectionsVIPProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.mutate({
          mutation: MAKE_SECTIONS_VIP,
          variables: {
            sectionIds: args?.sectionIds,
            isVip: args?.isVip,
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data?.makeSectionsVIP !== undefined) {
          return {
            success: res?.data?.makeSectionsVIP,
            notification: notification?.bulkUpgradeVipSuccess,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
